var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBarrel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6364 0.0727095V2.32724C12.5091 2.54542 13.1637 3.12729 13.5273 3.92729L12.3636 5.09091V8.72727H13.8182V11.2727C13.8182 12.2909 13.0182 13.0909 12 13.0909C10.9818 13.0909 10.1818 12.2909 10.1818 11.2727V0H0V16H10.1818V14.8364C10.7636 15.1273 11.3455 15.2727 12 15.2727C14.1818 15.2727 16 13.4545 16 11.2727V5.09091C16 2.54545 14.1091 0.436346 11.6364 0.0727095ZM7.27273 2.90909V6.54545H2.90909V2.90909H7.27273Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarrel);
export default __webpack_public_path__ + "static/media/icon-barrel.cf3c9e616e21dfa05d55426ff9eee1c5.svg";
export { ForwardRef as ReactComponent };